// @flow
import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getOrganisations,
  updateCurrentOrganisation
} from '../actions/organisations/organisationCreators';
import { getSetting } from '../actions/settings/settingsCreators';
import { updateCurrentLocation } from '../actions/locations/locationCreators';
import { setHasSeenDashboard } from '../actions/users/basicCreators';
import Banner from '../components/Banner';
import MainMenu from '../components/MainMenu';
import VideoModal from '../components/VideoModal';
import type { Dispatch } from 'redux';

type Props = {
  router: Object,
  organisations: any,
  currentOrganisation: Object,
  locations: any,
  currentLocation: Object,
  authentication: Object,
  settings: Object,
  updateCurrentLocation: (oid: number, s?: boolean) => void,
  getOrganisations: (oid?: number, p?: boolean, a?: boolean) => void,
  getLoggedInUser: Function,
  setHasSeenDashboard: () => void,
  updateCurrentOrganisation: Function,
  getSetting: (s: string) => void
};

type State = {
  showModal: boolean
};

class Dashboard extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showModal: false
    };
  }

  componentDidMount() {
    const { authentication, setHasSeenDashboard, getSetting } = this.props;
    getSetting('firstLogonIntroductoryInfoVideo');
    getSetting('dashboardAnnouncementText');

    if (!authentication.user.hasSeenDashboard) {
      this.setState({
        showModal: true
      });
      setHasSeenDashboard();
    } else {
      this.setState({
        showModal: false
      });
    }
  }

  close = () => {
    this.setState({ showModal: false });
  };

  render() {
    const {
      organisations,
      currentOrganisation,
      updateCurrentOrganisation,
      getOrganisations,
      locations,
      currentLocation,
      updateCurrentLocation,
      authentication,
      router,
      settings
    } = this.props;

    const videoUrl =
      settings && settings.firstLogonIntroductoryInfoVideo
        ? settings.firstLogonIntroductoryInfoVideo.value
        : undefined;
    const dashboardAnnouncementText =
      settings && settings.dashboardAnnouncementText
        ? settings.dashboardAnnouncementText.value
        : '';
    if (authentication.isLoggedIn) {
      return (
        <div className="dashboard" id="dashboard">
          {videoUrl && typeof videoUrl === 'string' && (
            <VideoModal
              showModal={this.state.showModal}
              close={this.close}
              videoUrl={videoUrl}
              title="Getting Started"
            />
          )}
          <Banner
            title="Dashboard"
            currentOrganisation={currentOrganisation}
            image="mailbox"
          />
          <div className="container">
            {dashboardAnnouncementText && (
              <div className="row dashboard-announcement">
                <div className="col-lg-12">
                  <h2>Announcement</h2>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: dashboardAnnouncementText
                    }}
                  />
                </div>
              </div>
            )}
            <MainMenu
              id="main-menu"
              organisations={organisations}
              currentOrganisation={currentOrganisation}
              updateCurrentOrganisation={updateCurrentOrganisation}
              getOrganisations={getOrganisations}
              subAccounts={locations}
              currentLocation={currentLocation}
              updateCurrentLocation={updateCurrentLocation}
              authentication={authentication}
              router={router}
            />
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

function mapStateToProps(state) {
  return {
    organisations: state.organisations,
    currentOrganisation: state.currentOrganisation,
    locations: state.locations,
    currentLocation: state.currentLocation,
    authentication: state.authentication,
    currentUser: state.currentUser,
    settings: state.settings
  };
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  return bindActionCreators(
    {
      getOrganisations,
      updateCurrentOrganisation,
      setHasSeenDashboard,
      updateCurrentLocation,
      getSetting
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/Dashboard.js